module.exports = __webpack_public_path__ + "static/media/ilustration_ok.b55aa009.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/illustration/ilustration_ok.svg
// module id = 342
// module chunks = 0